import { registerThemeSpec } from '@xhs/yam-beer/core/system/utils/themeSpec'

export default function initStyle() {
  return [
    registerThemeSpec('cmp.multicascade', {
      wrapper: {
        width: 178,
      },
      header: {
        height: 40,
        bg: '#fbfbfb',
        p: 12,
        fontSize: '14px',
        borderBottom: '1px solid #d9d9d9',
      },
      levelbox: {
        height: 266,
        overflow: 'auto',
      },
      empty: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 26,
        height: '100%',
        color: 'mute',
        fontSize: '14px',
        lineHeight: '20px',
      },
    }),
  ]
}
